
  import {Component, Vue, Prop, Watch} from 'vue-property-decorator';
  import {
    Action,
    Getter,
  } from 'vuex-class';
  import Card from '@/components/material/Card.vue';

  @Component({
    components: {Card},
  })
  export default class VEventList extends Vue {
    @Action('user/events/read') private readAll!: any;

    @Getter('user/events/all') private events!: any;

    private headers: any = [
      {
        text: 'Titel',
        align: 'left',
        value: 'title',
      },
      {
        text: '',
        align: 'left',
        sortable: false,
        value: '',
      },
    ];
    private loading: boolean = false;
    private search: string = '';

    private async mounted() {
      this.loading = true;
      await this.readAll();
      this.loading = false;
    }
  }
